import { render, staticRenderFns } from "./case-adjustment.vue?vue&type=template&id=266fff67&scoped=true"
import script from "./case-adjustment.vue?vue&type=script&lang=ts"
export * from "./case-adjustment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266fff67",
  null
  
)

export default component.exports